import React, { useEffect, useState } from "react";
import { Layout, Drawer, Tabs } from "antd";
import { connect } from "react-redux";
import _isEmpty from "lodash/isEmpty";
import { EllipsisOutlined, MenuOutlined } from "@ant-design/icons";
import AppRoutes from "../../routes";
import {
	fetchExhibFloorInfoRequest,
	updateCustomThemeStyle,
	updateIsEmbed
} from "../../appRedux/actions/ExhibitorFloor";
import { imageExists, defaultTheme } from "../../utils";
import {
	DEFAULT_PRIMARY_COLOR,
	DEFAULT_PRIMARY_DARK_COLOR,
	DEFAULT_PRIMARY_LIGHT_COLOR,
} from "../../constants";

const { Content } = Layout;
function AppLayout(props) {
	const [currentLogoWidth, setCurrentLogoWidth] = useState(0);
	const [drawerVisible, setDrawerVisible] = useState(false);
	const [logoImageURL, setLogoImageURL] = useState("");
	const [customStyle, setCustomStyle] = useState({});
	const [activeTab, setActiveTab] = useState('floorplan');
	const { exhibitor_hall_config, confurlid } = props?.appConfig || {};
	const { exhibitor_conference_home, exhibitor_register_now } = exhibitor_hall_config || {};
	const baseURL = confurlid ? `/${confurlid}/` : "";
	const buttonObj = [
		{
			url: "floorplan",
			imageSource: require("../../assets/images/icons/Floorplan_Icon.svg"),
			text: "Floor Plan",
			path: `${baseURL}floorplan`,
			visible: true,
			className: "nav-button-floorplan",
		},
		{
			url: "directory",
			imageSource: require("../../assets/images/icons/Company-Directory_Icon.svg"),
			text: "Directory",
			path: baseURL + "directory",
			visible: true,
			className: "nav-button-directory",
		},
		{
			url: "register",
			imageSource: require("../../assets/images/icons/Register-Now_Icon.svg"),
			text: "Register Now",
			path: baseURL + "register",
			externalLink: exhibitor_register_now,
			visible: exhibitor_register_now && !props.isEmbed ? true : false,
			className: "nav-button-register",
		},
		{
			url: "conference",
			imageSource: require("../../assets/images/icons/Conference-Home_Icon.svg"),
			text: "Conference Home",
			isLink: true,
			path: baseURL + "conference",
			externalLink: exhibitor_conference_home,
			visible: exhibitor_conference_home && !props.isEmbed ? true : false,
			className: "nav-button-conference",
		},
	];

	useEffect(() => {
		if(props.isEmbed){
			setActiveTab(props.location.pathname.split('/').pop())
		}
	}, [props.location.pathname,props.isEmbed])

	const reportWindowSize = () => {
		let headerWidth = document.querySelector(".header-logo")?.width;
		setCurrentLogoWidth(headerWidth);
	};

	window.addEventListener("resize", reportWindowSize);

	const handlClick = button => {
		if (drawerVisible) {
			setDrawerVisible(false);
		}
		if (button.externalLink) {
			window.open(button.externalLink, "_blank");
		} else if (!button.externalLink && button.path) {
			if(props.isEmbed){
				props.history.push(`/${confurlid}/${button.url}?embed=1`)
			} else {
				props.history.push(button.path);
			}
		}
	};

	const onEmbedTabChange = (url) => {
		setActiveTab(url)
		handlClick(buttonObj.find(obj => obj.url === url))
	}
	const renderNavOptions = () => {
		return buttonObj
			.filter(button => button.visible)
			.map((button, index) => {
				return (
					<div
						className={`nav-button nav-drawer-buttons ${props.location.pathname.includes(button.path) ? "nav-drawer-button-active" : ""
							}`}
						key={index}
						onClick={() => handlClick(button)}
					>
						<div>
							<img src={button.imageSource} className="nav-button-image" />
						</div>
						<div className="nav-button-text">
							<span>{button.text}</span>
						</div>
					</div>
				);
			});
	};

	const renderNavButtons = () => {
		return (
			<div className="gx-d-flex gx-ml-2 gx-align-items-center" style={{ flexGrow: 1 }}>
				{buttonObj
					.filter(button => button.visible)
					.map((button, index) => {
						return (
							<div
								key={index}
								onClick={() => handlClick(button)}
								className="gx-mx-auto gx-pointer gx-d-flex gx-align-items-center"
								style={{
									paddingBottom: "3px",
									borderBottom: props.location.pathname.includes(button.path)
										? "2px solid white"
										: "",
								}}
							>
								<img src={button.imageSource} className="nav-button-image gx-mr-3" />
								<h4 className="gx-mb-0 gx-text-white">{button.text}</h4>
							</div>
						);
					})}
			</div>
		);
	};
	const renderEmbedNavButtons = () => {
		return (
			<Tabs onChange={onEmbedTabChange} size='large' className="embedTabs app-text-color" activeKey={activeTab}>
				{buttonObj
					.map((button, index) => (button.visible
						? <Tabs.TabPane tab={button.text} key={button.url} />
						: null))}
			</Tabs>
		);
	};

	useEffect(() => {
		props.fetchExhibFloorInfoRequest();
		props.updateIsEmbed(props.location.search.includes("embed=1"));
	}, []);

	useEffect(() => {
		let PublicFloorplanConfig = JSON.parse(props.boothConfiguration.PublicFloorplanConfig ?? '{}')
		let siteLogo = PublicFloorplanConfig['SiteLogo'] ? PublicFloorplanConfig['SiteLogo'] : '';
		let coreAppImage = props?.appConfig?.core_app_images?.home750x300;
		imageExists(siteLogo, exists => {
			if (exists) {
				setLogoImageURL(siteLogo);
			} else {
				imageExists(coreAppImage, exists => { if (exists) setLogoImageURL(coreAppImage); });
			}
		});
		if (!_isEmpty(props.appConfig)) {
			const {
				styling = {},
				primary_color,
				primary_dark_color,
				primary_light_color,
			} = props?.appConfig;
			let styleObj = {
				primary_color: styling?.primary_color || primary_color || DEFAULT_PRIMARY_COLOR,
				primary_dark_color: styling?.dark || primary_dark_color || DEFAULT_PRIMARY_DARK_COLOR,
				primary_light_color:
					styling?.primary_light_color || primary_light_color || DEFAULT_PRIMARY_LIGHT_COLOR,
			};
			const setThemeStyles = styles => {
				const headerElement = document.body;
				for (const prop in styles) {
					headerElement.style.setProperty(prop, styles[prop]);
				}
			};
			if (!_isEmpty(styleObj)) {
				setThemeStyles({
					"--primary-color-val": styleObj["primary_color"],
					"--primary-dark-color-val": styleObj.primary_dark_color,
					"--primary-light-color-val": styleObj.primary_light_color,
				});
				props.updateCustomThemeStyle(styleObj);
			}
		}
	}, [props.appConfig, props.boothConfiguration]);

	useEffect(() => {
		if (logoImageURL) {
			let headerWidth = document.querySelector(".header-logo")?.width;
			setCurrentLogoWidth(headerWidth);
		}
	}, [logoImageURL]);

	return (
		<Layout className="app-layout bg-primary" style={{ height: '100%' }}>
			{props.isEmbed
				? (renderEmbedNavButtons())
				: (
					<header className="bg-primary">
						<div className="gx-p-4 gx-d-flex header-top">
							<img
								src={require("../../assets/images/icons/Lines.svg")}
								className="gx-ml-auto gx-my-auto gx-d-none gx-d-lg-block"
								style={{ width: "21rem" }}
							/>
						</div>
						<div className="bg-primary-dark header-band">
							<div
								className="bg-primary-dark gx-p-2 gx-d-lg-flex"
								style={{ overflow: "visible", height: "4.5em" }}
							>
								<div className="main-banner">
									<img
										src={logoImageURL}
										onError={e => (e.target.src = logoImageURL)}
										className="shadow-2"
									/>
								</div>
								{renderNavButtons()}
							</div>
						</div>
					</header>
				)}

			<Content className={`layout-content ${props.isEmbed ? '' : "gx-mt-5"}`}>
				<AppRoutes />
			</Content>
			<Drawer
				placement="left"
				className="nav-drawer"
				closable={false}
				onClose={() => setDrawerVisible(false)}
				visible={drawerVisible}
				getContainer={false}
				bodyStyle={{ maxWidth: 350, width: 270 }}
			>
				{renderNavOptions()}
			</Drawer>
		</Layout>
	);
}

const mapStateToProps = ({ exhibFloor }) => {
	return {
		appConfig: exhibFloor.config,
		loading: exhibFloor.loading,
		boothConfiguration: exhibFloor.boothConfiguration,
		isEmbed: exhibFloor.isEmbed,
	};
};

export default connect(mapStateToProps, {
	fetchExhibFloorInfoRequest,
	updateCustomThemeStyle,
	updateIsEmbed,
})(AppLayout);
